import { Story } from '../../DocTypes';

export const squaredButtonsStory: Story = {
  title: 'Squared buttons',
  description: 'List with items having squared buttons',
  coreComponent: {
    html: `<tag-list
    avatar-src-field='image'
    avatar-placeholder-field='placeholder'
    avatar-size='40px'
    primary-field='name'
    button-1-icon='Edit'
    button-1-squared
    button-2-icon='View'
    button-2-squared>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Jordan Norry',
        placeholder: 'JN',
      },
      {
        image: '',
        name: 'Sarah Young',
        placeholder: 'SY',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
        placeholder: 'SW',
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    avatarSrcField='image'
    avatarPlaceholderField='placeholder'
    avatarSize='40px'
    primaryField='name'
    button1Icon='Edit'
    button1Squared
    button2Icon='View'
    button2Squared
    data={[
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Jordan Norry',
        placeholder: 'JN',
      },
      {
        image: '',
        name: 'Sarah Young',
        placeholder: 'SY',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
        placeholder: 'SW',
      }
    ]}
  />`,
  },
};
